








import {Component, Vue} from "vue-property-decorator";
import Main from "@/components/Main.vue";
import Footer from "@/components/layout/Footer.vue";
import Navigation from "@/components/layout/navigation/Navigation.vue";
import NavigationBar from "@/components/layout/navigation/NavigationBar.vue";
import { NavigationLink } from "@/types/NavigationLinks";

@Component({
  components: {
    NavigationBar,
    Main,
    Footer,
    Navigation,
  }
})
export default class Index extends Vue {
  name!: "Index"

  links: Array<NavigationLink> = [
    {
      title: "home",
      to: "home",
      icon: "icon",
      local: true
    }, {
      title: "statuut_bevoegdheden",
      to: "statuut_bevoegdheden",
      icon: "icon",
      local: true
    }, {
      title: "cv",
      to: "cv",
      icon: "icon",
      local: true
    }, {
      title: "medewerkers",
      to: "medewerkers",
      icon: "icon",
      local: true
    }, {
      title: "jaarverslagen",
      to: "jaarverslagen",
      icon: "icon",
      local: true
    }, {
      title: "contact",
      to: "contact",
      icon: "icon",
      local: true
    }, {
      title: "klachten",
      to: "klachten",
      icon: "icon",
      local: true
    },
  ]

}
